// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Lcx5","productName":"Table_productName__1F-mK"};